export default __webpack_public_path__ + "img/Inter-BoldItalic_2cf00dc.woff2";